module.exports = __webpack_public_path__ + "static/colaboradores-03-12566ce6d7557b032facf13d09c37055.png";